module.exports = __webpack_public_path__ + "img/miaosu.c1ebad24.png";